import axios from 'axios';

// API configuration
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3002';
const API_KEY = process.env.REACT_APP_API_KEY || '';

// Create axios instance with default config
export const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    'x-api-key': API_KEY,
  },
});

// Request interceptor for adding auth token
apiClient.interceptors.request.use(
  (config) => {
    // Try vendor token first, then fallback to regular access token
    const vendorToken = localStorage.getItem('vendorAccessToken');
    const regularToken = localStorage.getItem('accessToken');
    const token = vendorToken || regularToken;
    
    if (token && !config.headers.Authorization) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor for handling errors
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    // Handle specific error codes
    if (error.response?.status === 401) {
      // Check for specific token-related errors that require clearing session
      const errorMessage = error.response?.data?.error || error.response?.data?.message || '';
      
      // Only clear tokens and redirect if token is invalid or expired
      // Don't clear on "Access token required" as user might be accessing a public page
      const shouldClearSession = 
        errorMessage.includes('Invalid access token') ||
        errorMessage.includes('expired') ||
        errorMessage.includes('Invalid or expired');
      
      if (shouldClearSession) {
        // Clear all tokens and session data
        localStorage.removeItem('vendorAccessToken');
        localStorage.removeItem('vendorRefreshToken');
        localStorage.removeItem('vendorSession');
        localStorage.removeItem('accessToken');
        localStorage.removeItem('refreshToken');
        
        // Redirect to login page (avoid redirect loops by checking current path)
        const currentPath = window.location.pathname;
        if (currentPath !== '/login' && !currentPath.startsWith('/onboarding/step1')) {
          // Store the current path as return URL
          const returnUrl = encodeURIComponent(currentPath);
          window.location.href = `/login?returnUrl=${returnUrl}`;
        }
      }
      // For "Access token required" or other 401s, just let the error propagate
      // The component/page can handle it appropriately
    }
    return Promise.reject(error);
  }
);

export default apiClient;

